import React from 'react';
import { Edit, SimpleForm, TextInput, ShowButton, required, regex } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import CustomLabelInput from '../components/CustomLabelInput';

function phoneNumberFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    } else if (phoneNumberString.length >= 14) {
        return phoneNumberString.substring(0, 14)
    } else {
        return phoneNumberString.substring(0, 14)
    }
}

const ContactEditActions = (props) => {
    const { basePath } = props;
    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <ShowButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const ContactEditGeneral = ({ record }) => {
    return (
        <div className="row mb-3 mb-md-0">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row">
                    <div className="col-12 col-xs-12 col-sm-12 col-md-12">
                        <TextInput source="display_name" label={<CustomLabelInput label="Name" />} fullWidth variant="outlined" validate={required()} />
                    </div>
                    <div className="col-12 col-md-6">
                        <TextInput placeholder="(000) 000-0000" source="phone" validate={regex(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Must be (000) 000-0000')} parse={phoneNumberFormat} label={<CustomLabelInput label="Phone" />} fullWidth variant="outlined" resettable />
                    </div>
                    <div className="col-12 col-md-6">
                        <TextInput source="email" label={<CustomLabelInput label="Email" />} fullWidth variant="outlined" />
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 px-4 pt-1">
                <ContactEditNotes record={record} />
            </div>
        </div>
    );
};

const ContactEditNotes = ({ record }) => {
    return (
        <div className="row">
            <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
            </div>
        </div>
    );
};

const ContactEdit = (props) => {
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit Contact</h3>
            <Edit className="m-0 p-0" title=" " actions={<ContactEditActions />} {...props}>
                <SimpleForm redirect="show">
                    <ContactEditGeneral className="mb-3" record={{ ...props }} />
                </SimpleForm>
            </Edit>
        </>
    )
};

export default ContactEdit;
